import { CheckNotes, InspectionCase } from '../inspection-cases';

export class MarkupRequirementsDto extends InspectionCase {
  item_9_1?: InspectionCase;
  item_9_2?: InspectionCase;
  item_9_3?: InspectionCase;
  item_9_4?: InspectionCase;
}

export class MarkupRequirements extends MarkupRequirementsDto {
  constructor(
    data: MarkupRequirementsDto = {
      title: 'דרישות סימון בהתקנתה בלוחות חשמל'
    }
  ) {
    super(data);
    this.item_9_1 = new InspectionCase({
      ...data.item_9_1,
      title: 'על גבי  המיכל יש סימון בהטבעה או צריבה של התוצרת והדגם'
    });
    this.item_9_2 = new InspectionCase({
      ...data.item_9_2,
      title: 'סוג המחולל, משקל, תאריך תפוגה'
    });
    this.item_9_3 = new InspectionCase({
      ...data.item_9_3,
      title: 'תאריך יצור'
    });
    this.item_9_4 = new InspectionCase({
      ...data.item_9_4,
      title: 'קיים שלוט ברור ובר קיימא על גבי הדלתות החיצוניות שללוחות החשמל'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_9_1.isApplicable || this.item_9_1.isPassed) &&
        (!this.item_9_2.isApplicable || this.item_9_2.isPassed) &&
        (!this.item_9_3.isApplicable || this.item_9_3.isPassed) &&
        (!this.item_9_4.isApplicable || this.item_9_4.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_9_1.getNotes(),
      ...this.item_9_2.getNotes(),
      ...this.item_9_3.getNotes(),
      ...this.item_9_4.getNotes()
    ];
  }
}
